import React, { useEffect, useState } from "react";
import ProfileIcon from "../../../assets/img/EventDashoardLogo/eventprofile.svg";
import { dashboardColors, theme } from "../../../themes/Theme";
import { KonfhubButton } from "../../../revampComponents/Atom/Buttons";
import CreateEventProfileModal from "./EventProfileModal/CreateEventProfileModal";

const CreateEventProfile = ({ fetchEventProfiles }) => {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = 'hidden'; // lock background when modal is open
        } else {
            document.body.style.overflow = 'auto';   // restore scroll when modal closes
        }
    }, [showModal]);

    const handleCreateProfile = (profileData) => {
        setShowModal(false);
    };

    return (
        <>
            <div>
                <div className="manage_events_container event-profile-bg">
                    <div className="event-profile-center">
                        <div className="event-profile-box">
                            <div className="event-profile-icon-wrap">
                                <img src={ProfileIcon} alt="Profile" className="event-profile-icon" />
                            </div>
                            <div className="event-profile-title">
                                Event Profiles to Streamline Event Creation
                            </div>
                            <div className="event-profile-desc">
                                Event Profiles let you pre-configure a group of settings that can be easily applied to any event.
                            </div>
                            <div className="event-profile-desc2">
                                Save time and ensure consistency by defining reusable profiles that include:<br />
                                <span className="event-profile-medium">Organiser Details, Team Members, Bank Details, Tax & Charges, Payment Methods</span> (for Indian Events),<br />
                                <span className="event-profile-medium">Payment Gateways</span> (for International Events), <span className="event-profile-medium">Branding Settings</span>
                            </div>
                            <div className="event-profile-action">
                                <span className="event-profile-medium mb-3" style={{ display: "block", marginBottom: 12, textAlign: "center" }}>To get started</span>
                                <KonfhubButton
                                    className="px-3"
                                    onClick={() => setShowModal(true)}
                                >
                                    Create a Profile
                                </KonfhubButton>
                            </div>
                        </div>
                    </div>
                </div>
                <CreateEventProfileModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    onCreate={handleCreateProfile}
                    fetchEventProfiles={fetchEventProfiles}
                    createProfile={true}

                />
            </div>

            <style jsx>{`
    .event-profile-bg {
        background: #f4f7fd;
        min-height: calc(100vh - 64px); /* subtract padding */
        padding: 32px 0;
        box-sizing: border-box;
        display: block;
    }

    .manage_events_container {
        margin: 0 !important;
        border-radius: 0px;
    }

    .event-profile-header {
        font-size: 18px;
        font-weight: 700;
        color: #183b56;
        margin-bottom: 18px;
        margin-left: 24px;
        margin-top: 0;
        padding-top: 24px;
    }

    .event-profile-center {
        width: 100%;
        max-width: 900px;
        padding: 0px 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        margin: 0 auto;
    }

    .event-profile-box {
        width: 100%;
        max-width: 750px;
        background: #fff;
        border: 1.5px dashed #C3CDDF;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 14px;
        margin: 0 auto;
    }

    .event-profile-icon-wrap {
        background: #eaf2fd;
        border-radius: 50%;
        width: 64px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 24px;
    }

    .event-profile-icon {
        width: 36px;
        height: 36px;
    }

    .event-profile-title {
        font-size: 18px;
        font-weight: 700;
        color: #222b45;
        margin-bottom: 10px;
        text-align: center;
    }

    .event-profile-desc {
        font-size: 16px;
        color: ${dashboardColors[theme].primaryTextColor};
        margin-bottom: 18px;
        text-align: center;
    }

    .event-profile-desc2 {
        font-size: 16px;
        color: ${dashboardColors[theme].primaryTextColor};
        margin-bottom: 24px;
        text-align: center;
    }

    .event-profile-medium {
        font-weight: 400;
    }

    .event-profile-btn {
        background: #003366;
        color: #fff;
        border: none;
        border-radius: 4px;
        padding: 10px 28px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.2s;
    }

    .event-profile-btn:hover {
        background: #1976d2;
    }

    .event-profile-action {
        text-align: center;
    }

    @media (max-width: 900px) {
        .event-profile-box {
            padding: 24px 16px;
        }
        .event-profile-header {
            margin-left: 8px;
            font-size: 16px;
        }
    }
`}</style>

        </>
    )
}

export default CreateEventProfile